import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Button,
  Uploader,
  Warning,
  ErrorMsg,
} from "@onegovbugs/onegov-react-components";
import { isCompleted, validate, scrollToError } from "../../../utils/Validation";
import styles from "./UploadDocument.module.scss";
import { saveApplication, storeDocumentDetail } from "../../../redux/actions";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import ScrollToTop from "../../../utils/ScrollToTop";
import DownloadSection from "../../../components/common/infoSection/InfoWithButtonSection";
import Important from '@material-ui/icons/Warning';
import PciWarning from "../../../components/common/pciWarning/PciWarning";

const UploadDocument = (props) => {
  RedirectIfCaptchaNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();
  const oidc = useSelector((state) => state.oidc);
  const accessToken = oidc.user && oidc.user.access_token;

  const documents = useSelector((state) => state.documentDetail);

  const application = useSelector((state) => state.application);
  const [filesAttached, setFilesAttached] = useState(
    documents && documents.documentList
      ? JSON.parse(documents.documentList)
      : []
  );
  const [poiFilesAttached, setPoiFilesAttached] = useState(
    documents && documents.poiDocumentList
      ? JSON.parse(documents.poiDocumentList)
      : []
  );
  
  const DownloadFile = (fileLink) => {
    window.open(fileLink, "_blank");
  };

  const poiDocTypesArray = [
    {
      value: "Driver Licence",
      label: "Driver Licence",
    },
    {
      value: "Photo Card",
      label: "Photo Card",
    },
    {
      value: "Passport Photo Page",
      label: "Passport Photo Page",
    },
    {
      value: "ADF Photo ID Card",
      label: "ADF Photo ID Card",
    },
    {
      value: "Other",
      label: "Other",
    }
  ]

  const documentTypesArray = [
    {
      value: "Additional project details",
      label: "Additional project details",
    },
    {
      value: "Additional questions",
      label: "Additional questions",
    },
    {
      value: "Additional staff list",
      label: "Additional staff list",
    },
    {
      value: "Animal ethics approval",
      label: "Animal ethics approval",
    },
    {
      value: "Bush regeneration checklist",
      label: "Bush regeneration checklist",
    },
    {
      value: "Fauna management plan",
      label: "Fauna management plan",
    },
    {
      value: "Maps",
      label: "Maps",
    },
    {
      value: "Publications",
      label: "Publications",
    },
    {
      value: "Referees report",
      label: "Referees report",
    },
    {
      value: "Site plan",
      label: "Site plan",
    },
    {
      value: "Species list",
      label: "Species list",
    },
    {
      value: "Translocational proposal",
      label: "Translocational proposal",
    },
    {
      value: "Vegetation management plan",
      label: "Vegetation management plan",
    },
    {
      value: "Works plan",
      label: "Works plan",
    },
    {
      value: "Other",
      label: "Other",
    },
  ];
  // validators
  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({
    filesAttachedDescription: false,
    filesAttachmentType: false,
    hasAttachment :  false,
    poiFilesAttachedDescription: false,
    poiFilesAttachmentType: false,
    poiHasAttachment :  false
  });
  useEffect(() => {
    validate(validators, setErrors);
  }, [filesAttached, poiFilesAttached]);

  const validators = [
    {
      fieldName: "filesAttachedDescription",
      fieldValue: filesAttached,
      isValid: (v) => {
        let flag = true;
        v.map((attachment) => {
          if ((!attachment.description || !isCompleted(attachment.description)) && attachment.status === 'done') {
            flag = false;
          }
        });
        return flag;
      },
    },
    {
      fieldName: "filesAttachmentType",
      fieldValue: filesAttached,
      isValid: v => {
        let flag = true;
        v.map(attachment => {
          if (!attachment.attachmentType && attachment.status === 'done') {
            flag = false;
          }
        });
        return flag;
      },
    },
    {
      fieldName: "hasAttachment",
      fieldValue: filesAttached,
      isValid: (v) => {
        let flag = false;
        v.map(attachment => {
          if (attachment.status === 'done') {
            flag = true;
          }
        });
        return flag;
      }
    },
    {
      fieldName: "poiFilesAttachedDescription",
      fieldValue: poiFilesAttached,
      isValid: (v) => {
        let flag = true;
        v.map((attachment) => {
          if ((!attachment.description || !isCompleted(attachment.description)) && attachment.status === 'done') {
            flag = false;
          }
        });
        return flag;
      },
    },
    {
      fieldName: "poiFilesAttachmentType",
      fieldValue: poiFilesAttached,
      isValid: v => {
        let flag = true;
        v.map(attachment => {
          if (!attachment.attachmentType && attachment.status === 'done') {
            flag = false;
          }
        });
        return flag;
      },
    },
    {
      fieldName: "hasPOIAttachment",
      fieldValue: poiFilesAttached,
      isValid: (v) => {
        let flag = false;
        v.map(attachment => {
          if (attachment.status === 'done') {
            flag = true;
          }
        });
        return flag;
      }
    }
  ];  

  const storeData = (finished) => {
    // delete rejected files
    filesAttached.map((attachment,i) => {
      if (attachment.status !== 'done') {
        filesAttached.splice(i, 1);
      }
    });
    poiFilesAttached.map((attachment,i) => {
      if (attachment.status !== 'done') {
        poiFilesAttached.splice(i, 1);
      }
    });

    const updatedPOIAttachments = poiFilesAttached.map((attachment,i) => {
      if (attachment.status == 'done') {
        return {...attachment, isPoiDocument: true};
      }
      return attachment;
    });
    
    const attachment = {
      documentList: JSON.stringify(filesAttached),
      poiDocumentList: JSON.stringify(updatedPOIAttachments),
      finished: finished,
      step : 8
    };
   
    dispatch(storeDocumentDetail(attachment));
  };

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12"}>
          <PciWarning />
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12"}>
          <h3>
            Please attach any additional information required to support your
            application.
          </h3>
        </div>
      </div>
      <DownloadSection
        title={"Additional questions"}
        info={
          "All applicants (except for those applying for Education or Bird/bat banding licence classes only) are required to complete these additional questions relating to potential impacts on threatened species and other environmental factors. Download and complete the form, save the document and upload it below."
        }
        onClick={() =>
          DownloadFile(
            "https://www.environment.nsw.gov.au/sites/default/files/2024-09/additional-scientific-licence-questions-190425.docx"
          )
        }
      />
      <div className={"row"}>
        <div className={"col-12"}>             
          <div className={styles.exclamation}>
            <div className={styles.exclamationIcon}><Important className={styles.icon} /></div>
            <div className={styles.exclamationCopy}>
              <p>
                If your project involves one or more of the following classes of
                licence, you will be required to submit additional information.
              </p>                     
        </div>
      </div>
        </div>
      </div>
      <div className={`row `}>
        <div className={`col-12`}>
          <div className={`${styles.infoSection}`}>
            <p>
              <label htmlFor={"bushRegeneration"}>Bush regeneration</label>
            </p>
            <p>
              You will need to upload <b>detailed site plans</b> and{" "}
              <b>programs of works for all sites</b>. You will also need to
              complete a <b>bush regeneration checklist,</b> which will be
              emailed to you shortly after your application is received.
            </p>
          </div>
        </div>
      </div>
      <div className={`row`}>
        <div className={`col-12`}>
          <div className={`${styles.infoSection}`}>
            <p>
              <label htmlFor={"bushRegeneration"}>Education</label>
            </p>            
            <p>
              If you are applying to hold protected fauna at a school or similar
              institution for educational purposes you must upload a copy of
              your animal ethics approval.
            </p>
            <p>
              Details may be found at{" "}
              <a
                href="http://nswschoolanimals.com/application-forms/application-form-3/"
                target="_blank"
              >
                School Ethics Approval
              </a>
            </p>
          </div>
        </div>
      </div>

      <DownloadSection
        title={"Translocation/reintroduction"}
        info={
          "Translocation proposal required. Download the template, prepare your proposal and upload it below."
        }
        onClick={() =>
          DownloadFile(
            "https://www.environment.nsw.gov.au/-/media/OEH/Corporate-Site/Documents/Animals-and-plants/Threatened-species/translocation-proposal-template-190163.docx?la=en&amp;hash=121A23107163EAFD91C74C3EC5BBA6E6504EA094"
          )
        }
      />

      <div className={"row"}>
        <div className={"col-12"}>
          <Warning type={"warning"}>
            <p>
              If you have any questions about the application process please
              email{" "}
              <a href="mailto:scientific.licensing@environment.nsw.gov.au">
                scientific.licensing@environment.nsw.gov.au
              </a>
            </p>
          </Warning>
        </div>
      </div>
  
      <hr className={styles.hrLine} />

     <div className={`row `}>
        <div className={`col-12`}>
          <h3>Additional Documents</h3>
        </div>
      </div>

      <div className={"row"}>
        <div className={`col-12`}>
          <Uploader
            baseUrl={process.env.REACT_APP_BASE_URL}
            uploadUrl={`/nativespeciesapi/V1/attachments/create`}
            removeUrl={`/nativespeciesapi/V1/attachments/delete`}
            onFilesChange={setFilesAttached}
            acceptExtra={
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
            files={filesAttached}
            uuid={application.applicationId}
            accessToken={accessToken}
            applicationId={application.applicationId}
            name={"scientificAttachments"}
            requireDescription
            documentTypes={documentTypesArray}
            {...props}
          />
          {errors.filesAttachedDescription && showErrors ? (
            <div className={"row"}>
              <div className={`col-6 ${styles.errorContainer}`}>
                <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Please add description of the file attached"}
                />
              </div>
            </div>
          ) : null}
          {errors.filesAttachmentType && showErrors ? (
            <div className={"row"}>
              <div className={`col-6 ${styles.errorContainer}`}>
                <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Please select the attachment type"}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {errors.hasAttachment && showErrors ? (
        <ErrorMsg
          className={"ErrorMsg_error"}
          type={"error"}
          description={"Please add attachment."}
        />
      ) : null}

      <div className={`row `}>
        <div className={`col-12`}>
          <h3>Proof of Identity</h3>
        </div>
      </div>

      <div className={`row `}>
        <div className={`col-12`}> 
             <div className={styles.info}>
               <div className={styles.infoCopy}>
                <p><b>Your application requires a valid proof of identity that matches the information in this application.</b></p>
                <p>
                   <b>You need to upload either:</b>
                   <ul className={styles.dashedList}>
                     <li>Driver's licence (front and back)</li>
                     <li>Photo Card (front and back)</li>
                     <li>Passport</li>
                     <li>ADF Photo ID Card</li>
                   </ul>
                 </p>
                 <p>
                    Drivers Licence or Photo Card:
                    <ul className={styles.dashedList}>
                     <li>Must be issued by an Australian State or Territory</li>
                     <li>Both front and back need to be uploaded</li>
                   </ul>
                 </p>
               </div>              
            </div>
          
        </div>
      </div>
      <div className={"row"}>
        <div className={`col-12`}>
          <Uploader
            baseUrl={process.env.REACT_APP_BASE_URL}
            uploadUrl={`/nativespeciesapi/V1/attachments/create`}
            removeUrl={`/nativespeciesapi/V1/attachments/delete`}
            onFilesChange={setPoiFilesAttached}
            acceptExtra={
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }
            files={poiFilesAttached}
            uuid={application.applicationId}
            accessToken={accessToken}
            applicationId={application.applicationId}
            name={"poiAttachments"}
            requireDescription
            documentTypes={poiDocTypesArray}
            {...props}
          />
          {errors.poiFilesAttachedDescription && showErrors ? (
            <div className={"row"}>
              <div className={`col-6 ${styles.errorContainer}`}>
                <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Please add description of the Proof of Identity file attached"}
                />
              </div>
            </div>
          ) : null}
          {errors.poiFilesAttachmentType && showErrors ? (
            <div className={"row"}>
              <div className={`col-6 ${styles.errorContainer}`}>
                <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Please select the Proof of Identity attachment type"}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {errors.hasPOIAttachment && showErrors ? (
        <ErrorMsg
          className={"ErrorMsg_error"}
          type={"error"}
          description={"Please add Proof of Identity attachment."}
        />
      ) : null}

      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                storeData(true);
                dispatch(
                  saveApplication("step8", () => {
                    props.history.push(`../../flora-fauna/dashboard`);
                  })
                );
                setShowErrors(false);
              } else {
                setShowErrors(true);
                scrollToError();
              }
            }}
          >
            Continue
          </Button>

          <Button
            secondary
            onClick={() => {
              storeData(false);
              dispatch(
                saveApplication("step8", () => {
                  props.history.push(`../../flora-fauna/dashboard`);
                })
              );
            }}
          >
            Save & exit section
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <UploadDocument {...props} />);
